import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    emailSubject: z.string().optional(),
    emailMessage: z.string().optional(),
    textMessage: z
      .string()
      .max(160, 'Text message must be 160 characters or less')
      .optional(),

    reminderDays: z.string().optional(),

    // Global Reminder - just if reminderDays !== '0'
    notifySubmits: z.array(z.string()).optional().nullable(),
    packetFormat: z.string().optional(),
    email_subject: z.string().optional().nullable(),
    email_body: z.string().optional(),
    sms_body: z
      .string()
      .max(160, 'Text message must be 160 characters or less')
      .optional(),
  })

export type SettingsTabFormModel = z.infer<ReturnType<typeof schema>>

export const useSettingsTabForm = () => {
  const settingsTabFormTypeSchema = schema()
  const { form, rule } = useFormWithZod(settingsTabFormTypeSchema)
  return { form, rule, schema: settingsTabFormTypeSchema }
}
